import { type OfferV11 } from '@redteclab/api/clients/bully'

export const productAccessorOfferHasSeller = (offer: OfferV11): boolean => {
  return Boolean(offer.seller)
}
